import React, { useState } from "react";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";

const EmployeeNotes = (props) => {
  const [Note, setNote] = useState("");
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN=""
        titleNameAR="الإجراءات"
        lang={"ar"}
        titleName="الإجراءات"
        child={[
            <div className="form-grid">
          <TextAreaAHSF
            fieldsName="EmployeeNotes"
            show={true}
            lang={"ar"}
            disabled={props.disabled}
            onChange={(e) => {
              setNote(e.target.value);
              props.setNote(e.target.value);
            }}
            // showValidationMessage={
            //   ValiationList?.includes("AboutScientificContributionArabic")
            //     ? true
            //     : false
            // }
            validationMessage={"حقل اجباري"}
          />
        </div>]}
      />
    </>
  );
};

export default EmployeeNotes;
